import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { CommonService } from 'src/app/shared/services/common.service';
import { StorageService } from '../cache/storage.service';
import { CommonAuthConstants } from '../authorization/auth.constants';
import { PermissionService } from '../services/permission.service';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate {
  constructor(
    private readonly commonService: CommonService,
    private readonly permissionService: PermissionService,
    private readonly storageService: StorageService,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return new Promise((resolve, reject) => {
      if (
        this.storageService.getAccessToken() &&
        !this.commonService.isTokenExpired(
          this.storageService.getAccessToken() || '',
        )
      ) {
        this.commonService.initializeRefreshTokenActivity();
        return this.permissionService
          .getScreenPermission()
          .then((permissions) => {
            if (permissions.length > 0) {
              const requiredPermission = route.data['key'];
              if (requiredPermission) {
                if (
                  this.permissionService.checkPermission(
                    `${CommonAuthConstants.common}:${requiredPermission}`,
                  )
                ) {
                  this.storageService.loginLogout.next('login');
                  return resolve(true);
                } else {
                  return resolve(false);
                }
              }
              return resolve(true);
            }
            this.commonService.resetAndNavigateToLogin();
            return resolve(false);
          });
      } else {
        this.commonService.resetAndNavigateToLogin();
        return resolve(false);
      }
    });
  }
}
